import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["platform", "urls"]

  connect() {
    console.log("app version connected")
  }

  changePlatform() {
    const versionId = this.platformTarget.value
    this.urlsTarget.innerHTML = `<option value="">Select Application URL</option>`
    if (!versionId) return

    fetch(`/v2/appversion/${versionId}/application_url_by_version`)
      .then(res => res.json())
      .then(data => {
        data.forEach(item => {
          const option = document.createElement("option")
          option.value = item.application_url
          option.textContent = item.name
          this.urlsTarget.appendChild(option)
        })
      })
  }
}
